export default "__VITE_ASSET__C2f0tsNm__"